export default "__VITE_ASSET__vMPdKcnz__"